/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import {
  setSelectedLanDeviceAction,
  setSelectedZoneDeviceAction,
  setIsAddNewLanDeviceAction,
  setIsAddNewIPInterfaceAction,
  setSelectedIPInterfaceAction,
  setLANDeviceIndexesAction,
  setLanDeviceListAction,
  setZoneDeviceListAction,
  setIPInterfaceListAction,
  setConfigCountsAction,
  setConfigStatusDataAction,
  setIsAddNewRfFeedAction,
  setSelectedRfFeedAction,
  setRfFeedListAction,
  setRfFeedIndexesAction,
  setIsAddNewZoneDeviceAction,
  setZoneIndexesAction,
  setLteX2ConnectionListAction,
  setSelectedLteX2ConnectionAction,
  setIsAddNewLteX2ConnectionAction,
  setLteX2ConnectionIndexesAction,
  setNgX2ConnectionIndexesAction,
  setNgX2ConnectionListAction,
  setSelectedNgX2ConnectionAction,
  setIsAddNewNgX2ConnectionAction,
  setRadioUnitIndexesAction,
  setIsZoneAddedAction,
} from "./actions";

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setLanDeviceList: setLanDeviceListAction,
    setZoneDeviceList: setZoneDeviceListAction,
    setIPInterfaceList: setIPInterfaceListAction,
    setRfFeedList: setRfFeedListAction,
    setSelectedLanDevice: setSelectedLanDeviceAction,
    setSelectedZoneDevice: setSelectedZoneDeviceAction,
    setSelectedRfFeed: setSelectedRfFeedAction,
    setIsAddNewLanDevice: setIsAddNewLanDeviceAction,
    setIsAddNewRfFeed: setIsAddNewRfFeedAction,
    setSelectedIPInterface: setSelectedIPInterfaceAction,
    setIsAddNewIPInterface: setIsAddNewIPInterfaceAction,
    setLANDeviceIndexes: setLANDeviceIndexesAction,
    setRfFeedIndexes: setRfFeedIndexesAction,
    setZoneCellIndexes: setZoneIndexesAction,
    setConfigCounts: setConfigCountsAction,
    setConfigStatusData: setConfigStatusDataAction,
    setIsAddNewZoneDevice: setIsAddNewZoneDeviceAction,
    setLteX2ConnectionIndexes: setLteX2ConnectionIndexesAction,
    setLteX2ConnectionList: setLteX2ConnectionListAction,
    setSelectedLteX2Connection: setSelectedLteX2ConnectionAction,
    setIsAddNewLteX2Connection: setIsAddNewLteX2ConnectionAction,
    setNgX2ConnectionList: setNgX2ConnectionListAction,
    setSelectedNgX2Connection: setSelectedNgX2ConnectionAction,
    setIsAddNewNgX2Connection: setIsAddNewNgX2ConnectionAction,
    setNgX2ConnectionIndexes: setNgX2ConnectionIndexesAction,
    setRadioUnitIndexes: setRadioUnitIndexesAction,
    setIsZoneAdded : setIsZoneAddedAction,
  },
});

export const DeviceConfigReducers = deviceSlice.reducer;
export const {
  setLanDeviceList,
  setZoneDeviceList,
  setIPInterfaceList,
  setSelectedLanDevice,
  setSelectedRfFeed,
  setSelectedZoneDevice,
  setIsAddNewLanDevice,
  setIsAddNewRfFeed,
  setSelectedIPInterface,
  setIsAddNewIPInterface,
  setIsAddNewZoneDevice,
  setLANDeviceIndexes,
  setRfFeedIndexes,
  setZoneCellIndexes,
  setConfigCounts,
  setConfigStatusData,
  setRfFeedList,
  setLteX2ConnectionList,
  setSelectedLteX2Connection,
  setIsAddNewLteX2Connection,
  setLteX2ConnectionIndexes,
  setNgX2ConnectionList,
  setSelectedNgX2Connection,
  setIsAddNewNgX2Connection,
  setNgX2ConnectionIndexes,
  setRadioUnitIndexes,
  setIsZoneAdded
} = deviceSlice.actions;
